import * as React from 'react';
import styled from '@emotion/styled';
import { Font } from '../../fonts';

export interface SelectOption {
  key: string;
  title: string;
}

export interface SelectInputWidgetProps {
  value: string;
  options: SelectOption[];
  onChange: (value: string) => any;
  className?: any;
}

export const SelectInputWidget: React.FC<SelectInputWidgetProps> = (props) => {
  return (
    <S.Container className={props.className}>
      {props.options.map((option) => {
        return (
          <S.Option
            selected={option.key === props.value}
            key={option.key}
            onClick={() => {
              props.onChange(option.key);
            }}
          >
            {option.title}
          </S.Option>
        );
      })}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    background: ${(p) => p.theme.forms.background};
    border: solid 1px ${(p) => p.theme.forms.border};
    border-radius: 3px;
    min-width: 250px;
    overflow: hidden;
  `;

  export const Option = styled.div<{ selected: boolean }>`
    color: ${(p) => p.theme.forms.foreground};
    font-family: ${Font.Normal};
    font-size: 16px;
    padding: 10px 10px;
    border-bottom: solid 1px ${(p) => p.theme.forms.border};
    background: ${(p) => (p.selected ? `${p.theme.forms.option_selected} !important` : 'transparent')};
    cursor: pointer;

    &:last-of-type {
      border-bottom: none;
    }

    &:hover {
      background: ${(p) => p.theme.forms.option_hover};
    }
  `;
}
